module.exports = __webpack_public_path__ + "img/DE01415.bfd6de49.svg";